import { datesForRange, segmentForDate, calculateValueBySegment } from 'src/utils/rollup';

export default function TransactionRollup(dateRange, txsByMonth) {
  // const filteredTransactions = excludeRefunds(transactions).filter((tx) => tx.amount > 0); // Get transactions without refunds and "Transfers" category
  const segments = datesForRange('month', dateRange?.start, dateRange?.end).sort(
    (a, b) => a.value - b.value
  );

  const dates = segments.map((e) => e.value);

  // assemble the results by segment
  const rollup = {};

  txsByMonth.forEach((obj) => {
    const idx = segmentForDate('month', convertToUTC(obj.timestamp?.toDate()), dates);
    const segment = segments[idx]?.label;

    const categories = { ...(rollup[segment] ?? {}) };

    if (segment != null) {
      Object.entries(obj?.transactions ?? {}).forEach(([key, value]) => {
        if (!categories[key]) {
          categories[key] = value;
        } else {
          categories[key] += value;
        }
      });
      rollup[segment] = categories;
    }
  });

  const valueInfo = calculateValueBySegment(rollup);

  return { rollup, segments, ...valueInfo };
}

export function convertToUTC(date) {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
}
